import React from 'react';
import { DefaultButton } from '@fluentui/react/lib/Button';
import { Stack } from '@fluentui/react/lib/Stack';
import Suggestion from '../../../models/Suggestion';
import styles from './SuggestionToolbar.module.scss';

interface SuggestionToolbarProps {
    chatMode: string;
    onClick: (message: string) => void;
    suggestions: Suggestion[];
}

const SuggestionToolbar: React.FC<SuggestionToolbarProps> = ({ chatMode, onClick, suggestions }) => {
    return (
        <Stack>
            <Stack.Item>
                {suggestions.map((suggestion: Suggestion, index) => (
                    <DefaultButton
                        key={index}
                        text={suggestion.name}
                        onClick={() => onClick(suggestion.prompt)}
                        className={styles.suggestionButton}
                    />
                ))}
            </Stack.Item>
        </Stack>
    );
};

export default SuggestionToolbar;
